export default __webpack_public_path__ + "static/event-teaser-382d43b19948fe5adceb9bc83e7b8d09.jpg";